import { Module } from "vuex";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { RootState } from "@/store/types";
import { RenderPostStatistic, RenderState, RenderVideoMetaData } from "@/services/render/types";
import { actions } from "@/store/render/actions";

export const state = {
    postStatistics: [] as RenderPostStatistic[],
    videoPostsMetaData: [] as RenderVideoMetaData[],
    currentSolutionTimezoneId: "",
    allowedOrigins: [] as String[]
} as RenderState;

const namespaced: boolean = true;

export const render: Module<RenderState, RootState> = {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
